<template>
  <transition name="fade">
    <div class="ui-toast" v-show="value">
      <slot></slot>
      <p class="toast-txt">{{toastTxt}}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: "nfToast",
  props: {
    // 是否顯示toast
    value: {
      type: Boolean,
      default: false
    },
    // toast提示文本
    toastTxt: {
      type: [String, Number],
      default: ""
    },
    // toast显示时长ms
    showTime: {
      type: [String, Number],
      default: 3000
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.timer = setTimeout(() => {
          this.$emit("input", false);
        }, this.showTime);
      }
    },
    toastTxt(newVal, oldVal) {
      let isSame = newVal === oldVal;
      if (!isSame) {
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$emit("input", false);
          }, this.showTime);
        }
      }
    }
  }
};
</script>

<style scoped>
.ui-toast {
  padding: 0.4rem;
  border-radius: 0.2rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  font-size: 0.32rem;
  z-index: 2;
  line-height: 1;
  height: 0.88rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
}
.toast-txt {
  text-align: center;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
</style>


